import {paginatorGetter} from "@/1_webapi/helpers";
import {
    KeywordsManagement__AddKeywordListQuery,
    KeywordsManagement__AddKeywordQuery,
    KeywordsManagement__BranchesCardsQuery, KeywordsManagement__DeleteKeywordQuery,
    KeywordsManagement__KeywordsQuery
} from "@/1_webapi/query";
import {checkConditions} from "@/2_app-logic/utils/utils";
import {api} from "@/main";


export default {
    namespaced: true,
    actions: {
        async changePage(ctx, page) {
            await api.keywordsManagement.changePage(ctx.state.domains.keywordsList, page)
        },
        async changePageSize(ctx, size) {
            await api.keywordsManagement.changePageSize(ctx.state.domains.keywordsList, size)
        },
        async sortBy(ctx, key) {

        },
    },
    mutations: {
    },
    state: {
        domains: {
            branchesCards: {
                query: new KeywordsManagement__BranchesCardsQuery(),
            },
            keywordsList: {
                query: new KeywordsManagement__KeywordsQuery(),
            },
            addOneKeyword: {
                query: new KeywordsManagement__AddKeywordQuery(),
            },
            addKeywordList: {
                query: new KeywordsManagement__AddKeywordListQuery(),
            },
            addKeywordsFile: {
                query: new KeywordsManagement__AddKeywordQuery(),
            },
            deleteKeyword: {
                query: new KeywordsManagement__DeleteKeywordQuery(),
            },
        },
    },
    getters: {
        domains(state) {
            return state.domains
        },
        branchesCards(state) {
            const response = state.domains.branchesCards.query.response
            if (checkConditions([response])) {
                return response.data
            }
        },
        keywordsList(state) {
            const response = state.domains.keywordsList.query.response
            if (checkConditions([response])) {
                return response.data
            }
        },
        paginator(state) {
            return paginatorGetter(state.domains.keywordsList.query)
        },
    },
}